<template>
    <div v-if="hasActivities">
        <h2 class="text-xl flex items-center mb-8"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> Zoznam aktivít {{ getTitle }}</h2>
        
        <div v-for="(latestActivity, index) in getActivities" :key="latestActivity.id">
            
            <div v-if="group === 'by_project'" class="mb-8">
                <div class="flex items-center pr-4 mb-4">
                    <h6 class="font-bold text-lg ml-4">{{ latestActivity[0].project.name }}</h6>
                    <span class="font-bold text-lg ml-auto">{{ formatTotal(getTime(latestActivity)) }}</span>
                </div>
                <div v-for="activity in latestActivity" class="w-full rounded-full shadow-md bg-white flex items-center my-3">
                    <div class="py-2 px-3 md:py-3 md:px-6 flex items-center bg-gray-200 rounded-full">
                        <span class="py-1 px-2 font-light text-xs w-32 md:w-20 text-center rounded-full text-white md:mr-4"
                              :class="activity.managers.length > 0 ? 'bg-'+activity.managers[0].color : 'bg-gray-400'">
                            <span v-if="!$isMobile">{{ activity.managers.length > 0 ? shortifyName(activity.managers[0].name) : 'Nepridelené' }}</span>
                            <span v-if="$isMobile">{{ activity.project.name }}</span>
                        </span>
                        <span v-if="!$isMobile" class="text-sm font-bold w-48">
                        <router-link class="text-black hover:text-orange-700 flex items-center" :to="{name: 'projects.detail', params: {projectId: activity.project.id}}">
                            {{ activity.project.name }}
                           <span class="text-primary ml-auto"><md-icon class="text-md">link</md-icon></span>
                        </router-link>
                    </span>
                    </div>
                    <div class="py-2 px-3 md:py-3 md:px-6 flex items-center w-full">
                        <span v-if="!$isMobile" class="md:ml-2 text-sm text-gray-500" v-html="activity.note"></span>
                        <span class="mr-3 ml-auto uppercase w-3 h-3 rounded-full" :class="activity.fixing ? 'bg-red-500' : ''" title="Oprava"></span>
                        <span v-if="typeof activity.tag !== 'undefined'" class="bg-gray-200 px-3 py-1 rounded-full text-xs text-gray-500"><font-awesome class="mr-1" icon="tag"></font-awesome> {{ activity.tag.name}}</span>
                        <span v-if="!$isMobile" class="text-md text-right mr-6 text-gray-400 w-24" :title="`${getDateTime(activity.start_timestamp)} - ${getDateTime(activity.end_timestamp)}`">{{ getOnlyTime(activity.start_timestamp) }} – {{ getOnlyTime(activity.end_timestamp) }}</span>
                        <span class="text-md font-bold">{{ formatTotal(activity.total_time) }}</span>
                        <router-link :to="{name: 'activities.edit', params: {id: activity.id}}" class="md-primary ml-4">
                            <md-icon class="md-primary">edit</md-icon>
                        </router-link>
                    </div>
                </div>
            </div>
            
            
            <div v-else-if="group === 'by_day'" class="mb-8">
                <div class="flex items-center pr-4 mb-4">
                    <h6 class="font-bold text-lg ml-4">{{ getDate(index) }}</h6>
                    <span class="font-bold text-lg ml-auto">{{ formatTotal(getTime(latestActivity)) }}</span>
                </div>
                <div v-for="activity in latestActivity" class="w-full rounded-full shadow-md bg-white flex items-center my-3">
                    <div class="py-2 px-3 md:py-3 md:px-6 flex items-center bg-gray-200 rounded-full">
                    <span class="py-1 px-2 font-light text-xs w-32 md:w-20 text-center rounded-full text-white md:mr-4"
                          :class="activity.managers.length > 0 ? 'bg-'+activity.managers[0].color : 'bg-gray-400'">
                        <span v-if="!$isMobile">{{ activity.managers.length > 0 ? shortifyName(activity.managers[0].name) : 'Nepridelené' }}</span>
                        <span v-if="$isMobile">{{ activity.project.name }}</span>
                    </span>
                        <span v-if="!$isMobile" class="text-sm font-bold w-48">
                        <router-link class="text-black hover:text-orange-700 flex items-center" :to="{name: 'projects.detail', params: {projectId: activity.project.id}}">
                            {{ activity.project.name }}
                           <span class="text-primary ml-auto"><md-icon class="text-md">link</md-icon></span>
                        </router-link>
                    </span>
                    </div>
                    <div class="py-2 px-3 md:py-3 md:px-6 flex items-center w-full">
                        <span v-if="!$isMobile" class="md:ml-2 text-sm text-gray-500" v-html="activity.note"></span>
                        <span class="mr-3 ml-auto uppercase w-3 h-3 rounded-full" :class="activity.fixing ? 'bg-red-500' : ''" title="Oprava"></span>
                        <span v-if="typeof activity.tag !== 'undefined'" class="bg-gray-200 px-3 py-1 rounded-full text-xs text-gray-500"><font-awesome class="mr-1" icon="tag"></font-awesome> {{ activity.tag.name}}</span>
                        <span v-if="!$isMobile" class="text-md text-right mr-6 text-gray-400 w-24" :title="`${getDateTime(activity.start_timestamp)} - ${getDateTime(activity.end_timestamp)}`">{{ getOnlyTime(activity.start_timestamp) }} – {{ getOnlyTime(activity.end_timestamp) }}</span>
                        <span class="text-md font-bold">{{ formatTotal(activity.total_time) }}</span>
                        <router-link :to="{name: 'activities.edit', params: {id: activity.id}}" class="md-primary ml-4">
                            <md-icon class="md-primary">edit</md-icon>
                        </router-link>
                    </div>
                </div>
            </div>
            
            
            <div v-else-if="group === 'all'">
                <div class="w-full rounded-full shadow-md bg-white flex items-center my-3" v-if="Object.keys(latestActivity).length > 0">
                    <div class="py-2 px-3 md:py-3 md:px-6 flex items-center bg-gray-200 rounded-full">
                        <span class="py-1 px-2 font-light text-xs w-32 md:w-20 text-center rounded-full text-white md:mr-4"
                              :class="latestActivity.managers.length > 0 ? 'bg-'+latestActivity.managers[0].color : 'bg-gray-400'">
                            <span v-if="!$isMobile">{{ latestActivity.managers.length > 0 ? shortifyName(latestActivity.managers[0].name) : 'Nepridelené' }}</span>
                            <span v-if="$isMobile">{{ latestActivity.project.name }}</span>
                        </span>
                        <span v-if="!$isMobile" class="text-sm font-bold w-48">
                        <router-link class="text-black hover:text-orange-700 flex items-center" :to="{name: 'projects.detail', params: {projectId: latestActivity.project.id}}">
                            {{ latestActivity.project.name }}
                           <span class="text-primary ml-auto"><md-icon class="text-md">link</md-icon></span>
                        </router-link>
                    </span>
                    </div>
                    <div class="py-2 px-3 md:py-3 md:px-6 flex items-center w-full">
                        <span v-if="!$isMobile" class="md:ml-2 text-sm text-gray-500" v-html="latestActivity.note"></span>
                        <span class="mr-3 ml-auto uppercase w-3 h-3 rounded-full" :class="latestActivity.fixing ? 'bg-red-500' : ''" title="Oprava"></span>
                        <span v-if="typeof latestActivity.tag !== 'undefined'" class="bg-gray-200 px-3 py-1 rounded-full text-xs text-gray-500"><font-awesome class="mr-1" icon="tag"></font-awesome> {{ latestActivity.tag.name}}</span>
                        <span v-if="!$isMobile" class="text-md text-right mr-6 text-gray-400 w-24" :title="`${getDateTime(latestActivity.start_timestamp)} - ${getDateTime(latestActivity.end_timestamp)}`">{{ getOnlyTime(latestActivity.start_timestamp) }} – {{ getOnlyTime(latestActivity.end_timestamp) }}</span>
                        <span class="text-md font-bold">{{ formatTotal(latestActivity.total_time) }}</span>
                        <router-link :to="{name: 'activities.edit', params: {id: latestActivity.id}}" class="md-primary ml-4">
                            <md-icon class="md-primary">edit</md-icon>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {formatTotal, shortifyName, sortObj} from "../../utils";

    export default {
        name: "Activities",
        
        metaInfo() {
            return {
                titleTemplate: chunk => {
                    return `Zoznam aktivít ${this.getTitle} - ` + this.$appName;
                },
            }
        },
        
        mounted() {
            this.$store.dispatch('fetchLatestActivity', {daysBack: 30, group: this.$route.params.group});
        },
        
        computed: {
            ...mapState({
                activities: state => state.latestActivity.activities,
            }),
            
            keys() {
                return Object.keys(this.activities);
            },
            
            
            group() {
                return this.$route.params.group;
            },
            
            hasActivities() {
                return Object.keys(this.activities).length > 0;
            },
            
            getActivities() {
                if(!this.activities.length) {
                    return {}
                }
                switch(this.$route.params.group) {
                    case "by_day":
                        return this.activities.groupBy("date");
                    case "by_project":
                        return this.activities.groupBy("project_id");
                    case "all":
                        return this.activities;
                }
            },
            
            getTitle() {
                switch(this.$route.params.group) {
                    case "by_project":
                        return "podľa projektu";
                    case "by_day":
                        return "podľa dňa";
                    case "all":
                        return "";
                }
            }
        },
        methods: {
            getDate(index) {
                return moment(index, "DD-MM-YYYY").format("DD.MM.YYYY");
            },
            
            getOnlyTime (date) {
                let time = moment.unix(date).local(false);
                return time.format('H:mm');
            },

            getDateTime (date) {
                let time = moment.unix(date).local(false);
                return time.format('DD.MM.YYYY HH:mm:ss');
            },

            shortifyName(name) {
                return shortifyName(name);
            },

            formatTotal(seconds) {
                return formatTotal(seconds);

            },
            getTime(activities = []) {
                let totalTime = 0;
                
                for(let activity of activities)
                    totalTime += activity.total_time;

                return totalTime;
            }
        },
        beforeDestroy() {
            this.$store.commit("clearLatestActivity");
        }
    }
</script>